import { setHours, setMinutes, setSeconds } from "date-fns";

import { AppointmentAvailability, AttendanceType, SystemDropdownParameter } from "@/api";
import { SystemDropdownParameterValue } from "@/common/constants/systemDropdownParameterValues";
import { SystemDropdownOptions } from "@/common/hooks/useSystemDropdownOptions";

import { AllDayEndHour, AllDayStartHour } from "./appointmentConstants";

export function toAllDayStart(date: Date): Date {
  return setSeconds(setMinutes(setHours(date, AllDayStartHour), 0), 0);
}

export function toAllDayEnd(date: Date): Date {
  return setSeconds(setMinutes(setHours(date, AllDayEndHour), 0), 0);
}

export function isKnownPurpose(purposeKey: string | null | undefined, purposes: SystemDropdownOptions): boolean {
  return !!purposeKey && purposes.options.some((option) => option.key === purposeKey);
}

export function isOverbookablePurpose(purposeKey: string | null | undefined, purposes: SystemDropdownOptions): boolean {
  return purposes.parameterOf(purposeKey, SystemDropdownParameter.Overbookable) === SystemDropdownParameterValue.True;
}

export function purposeAttendanceType(
  purposeKey: string | null | undefined,
  purposes: SystemDropdownOptions
): AttendanceType | null {
  const value = purposes.parameterOf(purposeKey, SystemDropdownParameter.AttendanceType);
  if (value === AttendanceType.Present || value === AttendanceType.Absent) {
    return value;
  }
  return null;
}

export function deriveAvailability(purposeKey: string, purposes: SystemDropdownOptions): AppointmentAvailability {
  return isOverbookablePurpose(purposeKey, purposes) ? AppointmentAvailability.Free : AppointmentAvailability.Busy;
}
